<script>
    import { Temperaments } from '../../../script/_data'
    export let Temperament, Equipment
</script>

<div class='temperament'>
    {#if Temperament > 0}
        추천 기질 : {Temperaments[Temperament].name}
    {:else}
        추천 기질이 없습니다.
    {/if}
</div>

<hr>

<div class='equipment'>
    {#if Equipment.length > 0}
        추천 장비 :
        <ul>
            {#each Equipment as item}
                <li>
                    <img
                        src="../img/equipment/equip/{item}.png"
                        alt="equip_{item}"
                    >
                </li>
            {/each}
        </ul>
    {:else}
        추천 장비가 없습니다.
    {/if}
</div>

<style lang="scss">
    .temperament {
        width: calc(100%);
        height: fit-content;
        font-size: 15px;
    }

    hr {
        margin: 8px 0;
        border: 1px solid $cl3;
    }

    .equipment {
        width: calc(100%);
        height: fit-content;
        font-size: 15px;

        ul {
            width: 100%;
            margin: 0;
            padding: 20px 0;
            display: flex;
            justify-content: space-between;

            li {
                width: 33%;
                list-style:none;

                img { width: 100%; }
            }
        }
    }

    @include mobile {
        .temperament { font-size: 12px; }
        .equipment {
            font-size: 12px;
        }
    }
</style>